import { useMemo } from "react"

import { SelectChangeEvent } from "@mui/material"
import { useFormikContext } from "formik"

import { Select } from "../../components/Select"

type FormValues = Record<string, string | string[] | null>

type FormikSelectProps = {
    color?: string
    name: keyof FormValues
    onChange?: (_newValue: string | string[] | null) => void
    multiple?: boolean
} & Omit<React.ComponentProps<typeof Select>, "name" | "value" | "onChange">

export const FormikSelect = (props: FormikSelectProps) => {
    const {
        color = "primary",
        name,
        onChange,
        multiple,
        ...selectProps
    } = props

    const { values, setFieldValue } = useFormikContext<FormValues>()

    const SelectComponent = Select

    const defaultValue = useMemo(() => {
        return multiple ? [] : ""
    }, [multiple])

    const onValueChange = (e: SelectChangeEvent<string>) => {
        const newValue = e.target.value
        const isNewValueResetting: boolean =
            newValue === null ||
            (Array.isArray(newValue) && (newValue as Array<string | null>).includes(null))

        const value: string | string[] = isNewValueResetting ? defaultValue : (newValue as string | string[])
        setFieldValue(name, value)
        onChange?.(value)
    }

    return (
        <SelectComponent
            name={name}
            color={color}
            onChange={onValueChange}
            value={values[name] ?? defaultValue}
            multiple={multiple}
            {...selectProps}
        />
    )
}